module.exports = __webpack_public_path__ + "img/tc-logo3.00ea42bf.png";